import React from 'react';

const SecondHeroSection = () => {
  return (
    <section
      className="h-[35vh] sm:h-[50vh] bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: "url('/images/morethanbg-1.webp')"
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
      />
      
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-3 sm:px-8 md:px-16 lg:px-24">
        <div className="text-center sm:text-left text-white max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
            We're more than just data,<br className="hidden sm:block" />
            <span className="sm:hidden"> </span><span className="font-bold" style={{ color: '#db0058' }}>we're driven by you.</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default SecondHeroSection;